module.exports = __webpack_public_path__ + "img/Facebook-checkin.c05e8081.svg";